// extracted by mini-css-extract-plugin
export var Logo = "styles-module--Logo--ZjN43";
export var TopLogo = "styles-module--TopLogo--bmOkj";